export default function ($http) {
    return function (vehicleId) {
        return $http({
            url: `api/vehicle/${vehicleId}/tags`,
            method: 'GET'
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/services/getAllEnquiryTags.js